import * as React from "react";
import type { SVGProps } from "react";
const SvgPerformanceActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fill="#252525"
      fillRule="evenodd"
      d="M10.625 2.417a.625.625 0 0 0-1.25 0v3.61a4.375 4.375 0 0 0-3.348 3.348h-3.61a.625.625 0 0 0 0 1.25h3.61a4.375 4.375 0 0 0 3.348 3.348v3.61a.625.625 0 0 0 1.25 0v-3.61a4.375 4.375 0 0 0 3.348-3.348h3.61a.625.625 0 0 0 0-1.25h-3.61a4.375 4.375 0 0 0-3.348-3.348v-3.61ZM10 13.625a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#252525"
      fillRule="evenodd"
      d="M10.442 10.058a.625.625 0 0 0-.884-.884l-2.5 2.5a.625.625 0 0 0 .884.884l2.5-2.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPerformanceActive;